// File Metadata:
// Filename: EditUser.js
// Version: 1.00
// Created: 2022-09-29 09:53:53
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useParams } from 'react-router-dom'
import EditUserForm from './EditUserForm'
import { useGetUsersQuery } from '../api/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'

const EditUser = () => {
	const { id } = useParams()

	const { user } = useGetUsersQuery('usersList', {
		selectFromResult: ({ data }) => ({
			user: data?.entities[id]
		})
	})

	if (!user) return <PulseLoader color='#fff' />

	const content = <EditUserForm user={user} />

	return content
}

export default EditUser
